import * as React from 'react';
import { Typography } from 'fronton-react';
import { getLocale, jc, getNumberFormatter } from 'utils';
import { ImagePlaceholder } from '@navi-toolbox/ui-components';
import { Styles } from './product.styles';
import { ProductProps } from '../types/product-props';
import { OutOfStockMessage } from './out-of-stock-message';
import { useTranslation } from 'react-i18next';

export namespace ProductBlocks {
  namespace Fmt {
    export const formatPrice = (locale: string, price: number) => {
      return getNumberFormatter(locale, {
        style: 'currency',
        currency: 'RUB',
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(price);
    };
  }

  /**
   * @deprecated Use ProductPriceView
   */
  export const Price: React.FC<{ price: number; onClick: () => void }> = ({ price, onClick }) => {
    const locale = getLocale();

    return (
      <Typography
        data-qa="price-sticky"
        onClick={onClick}
        variant="m"
        size="subtitle"
        className={Styles.price}
      >
        {Fmt.formatPrice(locale, price)}
      </Typography>
    );
  };

  export const Image: React.FC<{ url: string; description: string; onClick: () => void }> = ({
    description,
    onClick,
    url,
  }) => {
    const { t } = useTranslation();
    return (
      <ImagePlaceholder
        onClick={onClick}
        alt={description}
        fallbackAlt={t('ui.image.alt')}
        src={url}
        loading="lazy"
        className={Styles.image}
        fallbackWidth={40}
        fallbackHeight={40}
      />
    );
  };

  export const Description: React.FC<{ description: string }> = ({ description }) => {
    return (
      <Typography variant="s" size="body_short" className={Styles.description}>
        {description}
      </Typography>
    );
  };
}

export const MobileProduct: React.FC<ProductProps> = ({
  BasketItem,
  availabilityState,
  onSectionActivated,
  slots,
}) => {
  return (
    <>
      <div data-qa="mobile-product" className={Styles.mobileProduct}>
        <div className={Styles.leftSide}>
          {slots.image}
          <div className={Styles.textWrapper}>
            {slots.description}
            {availabilityState.availability === 'available' ? (
              slots.price
            ) : (
              <OutOfStockMessage onSectionActivated={onSectionActivated} />
            )}
          </div>
        </div>
        {availabilityState.availability === 'available' ? BasketItem : null}
      </div>
    </>
  );
};

export const TabletProduct: React.FC<ProductProps> = ({
  BasketItem,
  availabilityState,
  onSectionActivated,
  slots,
}) => (
  <>
    <div data-qa="tablet-product" className={Styles.tabletProduct}>
      {availabilityState.availability === 'available' ? (
        <>
          <div className={Styles.leftSide}>
            {slots.image}
            <div className={Styles.textWrapper}>
              <div>{slots.description}</div>
              {slots.price}
            </div>
          </div>
          <div>{/* div for `flex-shrink: 0` effect */ BasketItem}</div>
        </>
      ) : (
        <>
          <div className={Styles.leftSide}>
            {slots.image}
            <div className={jc(Styles.textWrapper, Styles.flexVerticalCenter)}>{slots.description}</div>
          </div>
          <OutOfStockMessage onSectionActivated={onSectionActivated} />
        </>
      )}
    </div>
  </>
);

export const MediumPlusScreenProduct: React.FC<ProductProps> = ({
  BasketItem,
  availabilityState,
  onSectionActivated,
  slots,
}) => (
  <>
    {availabilityState.availability === 'available' ? (
      <div className={jc(Styles.mediumPlusScreenProduct, 'spaceBetween')}>
        {slots.price}
        {slots.image}
        {BasketItem}
      </div>
    ) : (
      <div className={jc(Styles.mediumPlusScreenProduct, 'flexEnd')}>
        <OutOfStockMessage onSectionActivated={onSectionActivated} />
        {slots.image}
      </div>
    )}
  </>
);
